import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { NgbModalRef, NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { FormGroup, FormControl } from '@angular/forms';
import { SelectPossibleOption } from '../model/search';
import { I18n } from '@ngx-translate/i18n-polyfill';

@Component({
  selector: 'app-edit-value-modal',
  templateUrl: './edit-value-modal.component.html',
  styleUrls: ['./edit-value-modal.component.less']
})
export class EditValueModalComponent implements OnChanges, OnInit {
  closeResult: string;
  modalRef: NgbModalRef;
  @Input() type: string;
  @Input() initialValue: String | SelectPossibleOption;
  @Input() possibleValuesSelect: SelectPossibleOption[];
  @Output() newValue: EventEmitter<string | SelectPossibleOption>;
  @Input() icon: string;
  @Input() title: string;
  @Input() text: string;
  @Input() large: boolean;
  @Input() submit: string;
  @Input() cancel: string;
  newValueText: FormControl;
  newValueSelect: String;

  constructor(private modalService: NgbModal,
    private readonly i18n: I18n,
    ) {
    this.initialValue = '';
    this.possibleValuesSelect = [{ key: '', value: '' }];
    this.newValueText = new FormControl(this.initialValue);
    this.newValueSelect = this.possibleValuesSelect[0].key.valueOf();
    this.newValue = new EventEmitter<string | SelectPossibleOption>();
  }

  ngOnInit(): void {
    if (this.large)
      //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
      //Add 'implements OnInit' to the class.
      if (!this.title)
        this.title = this.i18n({
          id: 'writeNewValue',
          value: "Saississez la nouvelle valeur",
          description: "Saississez la nouvelle valeur",
          meaning: "edit-value"
        })
    if (!this.text)
      this.text = this.i18n({
        id: 'newValue',
        value: "Nouvelle valeur :",
        description: "Nouvelle valeur :",
        meaning: "edit-value"
      })
    if (!this.submit)
      this.submit = this.i18n({
        id: 'save',
        value: "Sauvegarder",
        description: "Sauvegarder",
        meaning: "edit-value"
      })
  }

  ngOnChanges(changes: SimpleChanges) {
  }

  open(content: any) {
    this.newValueText = new FormControl(this.initialValue);
    this.newValueSelect = this.initialValue.toString();
    this.modalRef = this.modalService.open(content, { backdropClass: 'backdropClassModal' });
    this.modalRef.result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
      if (this.type === 'text')
        this.newValue.emit(this.newValueText.value);
      else if (this.type === 'select')
        this.newValue.emit(this.newValueSelect.toString());
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/edit-value-modal/edit-value-modal.component.ts